import { createTheme } from '../utils/create-theme';
export var HEART_THEME = createTheme('heart', {
  activeMode: 'light',
  light: {
    color: {
      lineMid: '#00000022',
      appChrome: '#F5F5F5',
      primary: '#F82B60',
      primaryDarker: '#AC324C',
      primaryLight: '#FDBFCF',
      primaryLighter: '#D47693',
      primaryBright: '#EB6E73',
      primaryVeryLight: '#FEF0EC',
      link: '#F82B60',
      linkHover: '#000000',
      navigationActive: '#F82B60',
      accentDark: '#AC324C',
      accentLight: '#FDBFCF'
    }
  },
  dark: {
    color: {
      linkHover: '#7DB248'
    }
  }
});
export default HEART_THEME;